import { render } from "./ContactForm.vue?vue&type=template&id=97b5d596"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"

import "./ContactForm.vue?vue&type=style&index=0&id=97b5d596&lang=css"

import exportComponent from "/Users/ognjenq/Sites/petarboats/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__